export default "__VITE_ASSET__COrhVyt7__"